import { Component, ElementRef, OnInit, ViewChild, ɵSWITCH_TEMPLATE_REF_FACTORY__POST_R3__ } from '@angular/core';
import { Router } from '@angular/router';
import { Label } from 'ng2-charts';
import { ApiService } from '../../../../Services/api.service';
import { StorageService } from '../../../../Services/storage.service';
import { FormControl } from '@angular/forms';
import { SocketIOService } from '../../../../Services/socket.io.service';
import { VehicleLiveTrackService } from '../../../../store/vehicle/reducer';
import { SharedService } from '../../../../Services/shared.service';
import { MapService } from '../../../../Services/map.service';
import { CommonServices } from '../../../../Services/common.service';
import { async, Subject } from 'rxjs';
import { S3BudgetService } from '../../../../Services/s3Budget.service';
import { LoaderService } from '../../../../Services/loader.service';
import { rejects } from 'assert';
import { E } from '@angular/cdk/keycodes';
declare const mapUtilityMapBox;
declare const $;
declare var google: any;

@Component({
  selector: 'g10-transportManager-dashboardMenu_',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @ViewChild('dateTimeCheck') toPicker: ElementRef;
  isShowMaps: boolean = false;
  isShowList: boolean = true;
  mapHeight = '100%';
  reloadMap: boolean = false;
  summaryInfo: any = {};
  isVehicleDataHide: boolean = false;
  serchKey = 'reg'
  serchKey2 = 'title';
  public selectedTapRouteExploar: String = 'active';
  public startDateErr: string = '';
  public endDateError: string = '';
  public errorMessage: string = '';
  public dateHideShow: boolean = true;
  public datePrependIconShow: boolean = true;
  public vehRouteInfoHidePlot: boolean = false;

  // public vehFilterslider:boolean = true;
  public objKeys = Object.keys;
  public isRouteDataHide: boolean = true;
  public clickedVeh: string = '';
  //roster
  public isRosterDataHide: boolean = true;
  public selectedMap: string = 'osrm';
  // public selectedMap:string='google';
  private googleMapObj: any;
  public globalGoogleMarker: any;
  public rosterMapHeight: string = '100%';
  public showRosterDetails: boolean = false;
  public selEmp: any;
  public showRosterData: boolean = false;

  public listOfVehicle: any = {};

  public userRestrictionData: any = {};
  public showDashMods: boolean = false;
  offlineVehicles: any[];
  orgAllVehicle: any;

  constructor(
    public storage: StorageService,
    public api: ApiService,
    public router: Router,
    private socket: SocketIOService,
    private socketStore: VehicleLiveTrackService,
    private share: SharedService,
    private map: MapService,
    private comService: CommonServices,
    private s3: S3BudgetService,
    private loader: LoaderService
  ) {

    this.setDefaultDateTime();

    this.User_type = this.storage.get('userType');
    let users = this.storage.get('userInfo');
    if (users && users.map) {
      this.selectedMap = users.map;
    }
    if (users && users['fieldMap']) {
      // this.userRestrictionData=user['fieldMap'];
      // let subModulesOfDashboard=Object.keys(this.userRestrictionData.Dashboard.menu1);
      // let availSubMod=[];
      // for(let i=0;i<subModulesOfDashboard.length;i++){
      //   if(this.userRestrictionData && (this.userRestrictionData.Dashboard.checked || this.userRestrictionData.Dashboard.indeterminate) && this.userRestrictionData.Dashboard.menu1 && this.userRestrictionData.Dashboard.menu1[subModulesOfDashboard[i]] && (this.userRestrictionData.Dashboard.menu1[subModulesOfDashboard[i]].checked || this.userRestrictionData.Dashboard.menu1[subModulesOfDashboard[i]].indeterminate)){
      //     availSubMod.push(subModulesOfDashboard[i]);
      //   }
      // }
      const obj = {
        orgID: users.orgID
      };
      this.api.org_settingsList(obj).then((res: any) => {
        this.showDashMods = true;
        let mail = users.userEmail;
        let selectedUser = res.data['userInfo'].filter(e => e.userEmail == mail);
        users['fieldMap'] = selectedUser[0]['fieldMap'];
        this.storage.setData({ userInfo: users });
        let user = users;
        let availSubMod = [];
        if (user && user['fieldMap']) {
          this.userRestrictionData = user['fieldMap'];
          let subModulesOfDashboard = Object.keys(this.userRestrictionData['Dashboard'].menu1);
          for (let i = 0; i < subModulesOfDashboard.length; i++) {
            if (this.userRestrictionData && (this.userRestrictionData['Dashboard'].checked || this.userRestrictionData['Dashboard'].indeterminate) && this.userRestrictionData['Dashboard'].menu1 && this.userRestrictionData['Dashboard'].menu1[subModulesOfDashboard[i]] && (this.userRestrictionData['Dashboard'].menu1[subModulesOfDashboard[i]].checked || this.userRestrictionData['Dashboard'].menu1[subModulesOfDashboard[i]].indeterminate)) {
              availSubMod.push(subModulesOfDashboard[i]);
            }
          }
        }
        if (availSubMod.length > 0) {
          if (availSubMod[0] == 'Vehicle Information') {
            this.selecte = 'vehicleposition';
            this.dashbordMenuChange('vehicleposition');
          } else if (availSubMod[0] == 'Route Information') {
            this.selecte = 'routeinformation';
            this.dashbordMenuChange('routeinformation');
          } else if (availSubMod[0] == 'Roster') {
            this.selecte = 'roster';
            this.dashbordMenuChange('roster');
          }
        }
      }).catch((err) => {
        console.log(err);
      });

    }
    this.getVehicleData();

    const obj = {
      orgID: users.orgID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.orgAllVehicle = res && res.data;
      }
    });
    // this.vehFilterslider = this.storage.get('isMapActiveVeh');
    // if(this.vehFilterslider==undefined) this.vehFilterslider = true;
    this.share._subject.subscribe(async (data: any) => {
      if (data.type == 'socketData') {
        await this.getReports()
        setTimeout(() => {
          this.filterData(this.selectedType);
        }, 200)

        // console.log('socket -- ', data.data);

      }
    });


  }
  routeInfoAll = {
    vechileCnt: 40,
    pickup: 25,
    drop: 15,
    assigned: 35,
    running: 30,
    employe: 600,
    male: 350,
    female: 250,
    borded: 60,
    deboarded: 50,
    nopresent: 10,
    sosCnt: 20,
    activeCompliants: 40,
    overdueCompliants: 30,
    routeTime: '12:30',
    routePoint: 'velachery',
    pickCnt: 60
  }
  //public routeList = RouteData
  public routeList = [];
  public noActiveRouteEnable = false;

  isShowTableSearch = false;
  isHideTab = false;
  public searchInput: any = new Subject<string>();
  searchedValue: any = '';
  selectedVehicle: any = {};
  removeVehicle: any = {};
  selecte = 'vehicleposition';
  public tpmDashboardMenu = [{
    label: 'Dashboard',
    icon: 'dashboard',
    path: '/organization/transport-manager/dashboard',
  },
  {
    label: 'SOS Panel',
    icon: 'error',
    path: '/organization/transport-manager/sospanel',
  },
  {
    label: 'Request',
    icon: 'compare_arrows',
    path: '/organization/transport-manager/request-component',
  },
  {
    label: 'Rostering ',
    icon: 'call_split',
    path: '/organization/transport-manager/rostering ',
  },
  {
    label: 'Reports',
    icon: 'report_problem',
    path: '/organization/transport-manager/reports',
  },
  {
    label: 'Information',
    icon: 'info',
    path: '/organization/transport-manager/information',
  },
    // {
    //   label:'List View',
    //   icon:'list_alt',
    //   path:'/organization/transport-manager/listview',
    // },
    // {
    //   label: 'Support Desk',
    //   icon: 'contact_support',
    //   path: '/organization/transport-manager/support-desk',
    // },
  ];
  public dot;
  public myMap: any = this.map.retMap();
  public mousePos = 0;
  public currentTab = 'Dashboard';
  public currentPath = '/organization/transport-manager/dashboard';
  public allVehicleStatusInfo = [];
  public noVehicleEnable: boolean = false;

  public tabs = {
    isRouteSummary: true,
    isRouteExploration: false,
    isRouteInformation: false,
    isOpenBookingSummary: false,
  }


  selected = new FormControl(0);
  public vehicleStatusTab: any = [
    { lable: 'All', class: 'tablinks active', param: 'all' },
    { lable: 'Moving', class: 'tablinks', param: 'moving' },
    { lable: 'Halt', class: 'tablinks', param: 'halt' },
    { lable: 'Late Update', class: 'tablinks', param: 'lateUpdate' }
  ];
  public pieChartLabels: Label[] = [['All'], ['Denied'], 'Accept'];
  public pieChartData: number[] = [300, 200, 100];
  User_type: any;
  userData: any;
  VendorInfos: any;
  public showFiller = false;
  public navIcon = 'navigate_next';
  selectedType: any;
  routeInfoSearchedValue: string = ''
  singleViewVehicle: any;
  // -------------------------
  public allVehiCnt: any = 0; movingCnt: any = 0; haltCnt = 0; lastCnt = 0;
  // ------------------------------------

  // ---------------------
  public allVehicle: any = {
    cnt: {
      all: 0,
      movement: 0,
      halt: 0,
      lastUpdate: 0,
      offline: 0
    },
    info: {
      all: [],
      movement: [],
      halt: [],
      lastUpdate: []
    }
  };
  enableDateTime: boolean = false;
  disableDate: boolean = true;
  defaultEDate: string = '';
  maxEndDate = "today";
  maxDate = new Date().toISOString().slice(0, 10);
  public startDate;
  public endDate;
  public routeTabCounts = { active: 0, all: 0, upcoming: 0 };
  public routeTabData = { active: [], all: [], upcoming: [] };
  public routeData = [];

  // single route data 
  public selectedRoute: any = {};
  public activeRouteExploration: boolean = true;
  public selectedRoutes = [];
  vehicleRegNos: any;

  /* Total distance */
  public enableTotDis: boolean = false;
  public totalDistance: any = 0;

  ngOnInit(): void {


    this.getUserData(() => {
      if (this.User_type != 'transport_manager') {
        this.router.navigate(['/organization/transport-manager/login']);
      }
      let chekRouteExplore = this.storage.get('routeExploration');
      if (chekRouteExplore != undefined && chekRouteExplore != null && chekRouteExplore != '') {
        // this.isVehicleDataHide = chekRouteExplore['isVehicleDataHide'];
        this.selecte = 'routeinformation';
        this.selectedTapRouteExploar = chekRouteExplore['selectedTapRouteExploar'];
        this.dashbordMenuChange('routeinformation');

        setTimeout(() => {
          this.selectRoute(chekRouteExplore['selectedRoute']);
          // this.storage.setData({ 'routeExploration': '' });
        }, 500)
        // this.route.navigate(['organization/transport-manager/dashboard']);
      }

      const orgInfo = this.storage.get('userInfo');
      setTimeout(() => {
        if (orgInfo.orgID != undefined && orgInfo.orgID != null && orgInfo.orgID != '') {

          this.getVehicleDetails(orgInfo.orgID)
          this.socket.getMessages();
          this.getActiveRouteInfo(orgInfo.orgID);

        }

        this.currentPath = this.router.url;
        this.defaultCircle(this.tpmDashboardMenu, this.currentPath);

        // console.log('lab content loading from ngOnInit');
        this.loadTabContant('all');
      }, 500);
      this.api.getOrgVehicleRegNos({}).then((res: any) => {
        if (res.status == 'success') {
          this.vehicleRegNos = res.data;
        }
      }).catch((err) => {
        console.log(err);
      });

    });


    // setTimeout(() => {

    // const orgInfo = this.storage.get('userInfo');
    // console.log('orgInfo ', orgInfo)
    // setTimeout(() => {
    //   if (orgInfo.orgID != undefined && orgInfo.orgID != null && orgInfo.orgID != '') {

    //   this.socket.getMessages();
    //     this.getVehicleDetails(orgInfo.orgID);
    //     this.getActiveRouteInfo(orgInfo.orgID);
    //   }

    //   this.currentPath = this.router.url;
    //   this.defaultCircle(this.tpmDashboardMenu, this.currentPath);

    //   // console.log('lab content loading from ngOnInit');
    //   this.loadTabContant('all');
    // }, 300);

    // this.api.getOrgVehicleRegNos({}).then((res: any) => {
    //   if (res.status == 'success') {
    //     this.vehicleRegNos = res.data;
    //   }
    // }).catch((err) => {
    //   console.log(err);
    // });

    // }, 300);
    // this.getS3()
    /*  $('#datetimepicker').datetimepicker({
       format:'Y-m-d H:i',
       inline:true
   }); */
  }

  getUserData(CB) {
    this.api.GetCurUserOrg({}).then((res: any) => {
      if (res.status == 'success') {
        this.storage.setData({ userInfo: res.data[0] });
        // this.socket.getMessages();
      }

      CB();
    }).catch((err) => {
      console.log(err);
    });
  }
  // async getS3() {
  //   console.log('GET S3 Budget')
  //   let res = await this.s3.s3GetFile({
  //     "Bucket": "dzrjjsqnpdynylcuvsgahznfioxxkjuj-emps.g10.pw/org-assets/vehicles/60866279d774d4408635033b/60cae868ef11c5a004e910b6/testimageload/testimageload",
  //     "Key": "rajatest"
  //   });

  //   console.log('RES S3 ', res);
  // }

  selectRoute(val) {
    this.routeInfoAll = val;
    this.selectedRoute = val;
    this.loadSelectedRoute();
  }

  loadSelectedRoute() {
    this.tabs.isRouteInformation = false;
    setTimeout(() => { document.getElementById(this.selectedRoute.routeID).click(); }, 100);
  }

  deleteSelectedRoute(event) {
    event.preventDefault();
    if (this.tabs.isRouteInformation) {
      this.enableRouteExploration();
      this.selectedRoute = {};
    }
  }

  enableRouteExploration() {
    document.getElementById("pills-route-exploration-tab").click();
  }
  dashbordMenuChange(val) {
    // console.log(val)
    this.showRosterDetails = false;
    this.showRosterData = false;
    this.rosterMapHeight = '100%';
    this.selectedVehicle = {};
    this.removeVehicle = {};
    this.reloadMap = true;
    if (val == 'routeinformation') {
      this.isVehicleDataHide = true;
      this.isRouteDataHide = false;
      this.isRosterDataHide = true;
    }
    if (val == 'vehicleposition') {
      this.isVehicleDataHide = false;
      this.isRouteDataHide = true;
      this.isRosterDataHide = true;
    }
    if (val == 'roster') {
      this.showRosterData = true;
      this.isVehicleDataHide = true;
      this.isRouteDataHide = true;
      this.isRosterDataHide = false;
      this.loadMap();
    }
    if (this.isVehicleDataHide) {
      this.reloadTab('isRouteSummary');
      this.activeRouteExploration = false;
      this.selectedRoute = {};
    }

    setTimeout(() => { this.reloadMap = false; })
  }
  currentPage(tabIndex: number) {
    this.currentTab = this.tpmDashboardMenu[tabIndex].label;
    this.currentPath = this.tpmDashboardMenu[tabIndex].path;
    this.getLable(tabIndex);
  }

  // Moving Dashboard Menu circleIcon
  changeCirclePos(value: number) {
    this.mousePos = value;
  }

  loadTabContant(type: string) {
    this.noVehicleEnable = false;
    this.selectedType = type;
    this.allVehicleStatusInfo = [];
    if (type == 'all') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.all];
      if (this.offlineVehicles != undefined && this.offlineVehicles?.length > 0) {
        this.offlineVehicles.filter((veh) => { this.allVehicleStatusInfo.push(veh) })
      }
      this.allVehicle.cnt.all = this.allVehicleStatusInfo.length;
    } else if (type == 'moving') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.movement];
    } else if (type == 'halt') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.halt];
    } else if (type == 'lateUpdate') {
      this.allVehicleStatusInfo = [...this.allVehicle.info.lastUpdate];
    } else if (type == 'offline') {
      this.allVehicleStatusInfo = this.offlineVehicles;
      this.allVehicle.cnt.offline = this.offlineVehicles.length;
    }
    if (this.allVehicleStatusInfo.length > 0) this.noVehicleEnable = true;
    else {
      setTimeout(() => {
        this.noVehicleEnable = true;
      }, 500);
    }
    // console.log(type);
    // this.filterData(type);
    if (this.allVehicleStatusInfo.length > 0 && this.allVehicleStatusInfo != undefined) {
      this.getAllVehicleForDash(this.allVehicleStatusInfo);
    }

  }
  getVehicleData() {

    this.api.transportManagerVehicleList({}).then((res: any) => {
      if (res.status == 'success') {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            this.listOfVehicle[res.data[i]['vehRegNo']] = res.data[i]['model']
          }

        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getAllVehicleForDash(data) {

    let vehRegs = []
    data.map(live_veh => vehRegs.push(live_veh.reg))
    let obj = {
      "vehRegNo": vehRegs
    }

    this.api.transportManagerAllAssignedVehicleDash(obj).then(res => {

      if (res['data'].length > 0 && this.allVehicleStatusInfo.length > 0) {
        let vehList = res['data']
        this.allVehicleStatusInfo = this.allVehicleStatusInfo.filter(liveVeh =>
          vehList.map(item => {
            if (liveVeh['reg'].includes(item['vehRegNo'])) {
              liveVeh['vehDetail'] = item;
            }
          })
        )
      }
    }).catch(err =>
      console.log("Error", err)
    )
  }
  async filterData(type?) {
    // console.log('update ', type);
    this.allVehicleStatusInfo = [];
    this.allVehicle.info.all = [];
    this.allVehicle.cnt.all = 0;
    this.allVehicle.cnt.movement = 0;
    this.allVehicle.cnt.halt = 0;
    this.allVehicle.cnt.lastUpdate = 0;
    this.allVehicle.cnt.offline = 0;
    this.allVehicle.info.lastUpdate = [];
    this.allVehicle.info.halt = [];
    this.allVehicle.info.movement = [];
    this.allVehicle.info.offline = [];
    const data = this.socketStore.get();
    const currnentTMS = new Date().getTime();
    // console.log("datsssss",data)
    const restrictedDays = new Date().setDate(new Date().getDate() - 2);
    const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
    const restrictedTimestamp = new Date(restrictedDatetime).getTime();
    data.filter(async (item: any) => {
      if (item != undefined && item.gpsts != undefined) {
        const timeDiff = this.comService.timeDiff(item.gpsts, currnentTMS);
        // const timeDiff = this.comService.timeDiff((String(item.gpsts).length > 10 ? item.gpsts : item.gpsts * 1000), currnentTMS);
        // console.log('Line 260 --> ', timeDiff, 'item.gpsts ', item.gpsts, 'currnentTMS ', currnentTMS)
        /*       if (timeDiff.hh > 4 && item.spd > 5) {
                this.allVehicle.info.lastUpdate.push(item);
                this.allVehicle.cnt.lastUpdate = this.allVehicle.info.lastUpdate.length;
              } else {
                if (item.spd <= 5) {
                  this.allVehicle.info.halt.push(item);
                  this.allVehicle.cnt.halt = this.allVehicle.info.halt.length;
                } else if (item.spd > 5 && timeDiff.hh <= 4) {
                  this.allVehicle.info.movement.push(item);
                  this.allVehicle.cnt.movement = this.allVehicle.info.movement.length;
                }
              } */
        /*  if (restrictedTimestamp < (item.gpsts.length > 10 ? item.gpsts : item.gpsts * 1000)) {
         } */
        if (timeDiff.hh <= 72) {
          this.allVehicle.info.all.push(item);
          this.allVehicle.cnt.all++;
          if ( timeDiff.hh > 4 && timeDiff.hh < 72) {
            this.allVehicle.info.lastUpdate.push(item);
            this.allVehicle.cnt.lastUpdate = this.allVehicle.info.lastUpdate.length;
          } else {
            if (item.spd <= 5 || (timeDiff.minute >= 10 && timeDiff.hh <= 4)) {
              if (item.spd < 0) item.spd = 0;
              this.allVehicle.info.halt.push(item);
              this.allVehicle.cnt.halt = this.allVehicle.info.halt.length;
            } else if (item.spd > 5 &&  timeDiff.minute < 10 ) {
              this.allVehicle.info.movement.push(item);
              this.allVehicle.cnt.movement = this.allVehicle.info.movement.length;
            } 
          }
        }

      }


    });

    // console.log(this.allVehicle);
    this.allVehicle.cnt.offline = this.offlineVehicles?.length;
    if (type == 'all') {
      this.allVehicleStatusInfo = this.allVehicle.info.all;
      // if (this.offlineVehicles?.length > 0) {
      //   this.offlineVehicles.filter((veh) => { this.allVehicleStatusInfo.push(veh) })
      // }
      // console.log('this.allVehicleStatusInfo', this.allVehicleStatusInfo)
    } else if (type == 'moving') {
      this.allVehicleStatusInfo = this.allVehicle.info.movement;
    } else if (type == 'halt') {
      this.allVehicleStatusInfo = this.allVehicle.info.halt;
    } else if ('lateUpdate') {
      this.allVehicleStatusInfo = this.allVehicle.info.lastUpdate;
    } else if ('offline') {
      this.allVehicleStatusInfo = this.offlineVehicles;

    }
  }

  getReports() {
    // this.api.getCurrentLocation({}).then((res: any) => {
    //   if (res.status == 'success') this.getValidateVehicle(res['data']);
    // });
  }
  getValidateVehicle(latestData) {
    this.offlineVehicles = [];
    let inc = 1;
    const currnentTMS = new Date().getTime();
    for (let i = 0; i < this.orgAllVehicle.length; i++) {

      let regNo = this.orgAllVehicle[i]['vehRegNo'];

      for (let l = 0; l < latestData.length; l++) {
        let vehicle = JSON.parse(latestData[l]);
        const timeDiff = this.comService.timeDiff(vehicle.gpsts, currnentTMS);
        if (regNo == vehicle['reg'] && timeDiff && timeDiff.hh > 72) {
          this.offlineVehicles.push(vehicle)
        }
      }
    }
  }

  // Default Dashboard Menu circleIcon
  defaultCirclePos() {
    this.mousePos = this.dot;
  }
  defaultCircle(obj, value) {
    this.dot = Object.keys(obj).find(key => obj[key].path == value);
    this.currentTab = obj[this.dot].label;
    this.mousePos = this.dot;
  }
  getVehicleStatus(obj: any) {
    // console.log('geT DATa', this.socketStore.get());
    // console.log('lab content loading from status');
    this.loadTabContant('all');
    this.filterData(this.selectedType);

  }
  getVehicleDetails(orgID: any) {
    const obj = { orgID };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      const orgVeh: any = {};
      orgVeh[orgID] = res.data;
      // this.orgAllVehicle = res.data
    });
  }

  getLable(t) {
    this.storage.setData({ tabValue: t });
    // console.log(t, this.selected)
  }

  mapBarChart() {
    this.closeNav()
    this.isShowMaps = !this.isShowMaps;
  }
  sideNav() {
    this.showFiller = !this.showFiller;
    if (this.showFiller) {
      this.navIcon = 'navigate_before';
    } else {
      this.navIcon = 'navigate_next';
    }
  }
  checkSpeedColor(value, gpsts) {
    const spd = Number(value);
    const currnentTMS = new Date().getTime();
    const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);
    if (this.selectedMap == 'google') {
      if (timeDiff.hh > 4 && timeDiff.hh < 72) return 'fontcolor_grey';
      if (spd > 5 &&  timeDiff.minute < 10 ) {
        if (spd > 59) { return 'fontcolor_olive'; }
        else { return 'fontcolor_yellow'; }
      } else { return 'fontcolor_red'; }
    } else {
      if (timeDiff.hh > 4 && timeDiff.hh < 72) return 'fontcolor_grey';
      if (spd > 5 &&  timeDiff.minute < 10 ) {
        if (spd > 59) { return 'fontcolor_olive'; }
        else { return 'fontcolor_yellow'; }
      } else { return 'fontcolor_red'; }
    }
  }
  openNav(item) {
    if (this.clickedVeh == '' || this.clickedVeh != item.reg) {
      this.startDate = undefined;
      this.endDate = undefined;
      this.errorMessage = 'false';
      this.clickedVeh = item.reg;
      this.isVehicleDataHide = true;
      this.isShowList = false;
      this.reloadMap = true;
      this.selectedVehicle = {};
      this.singleViewVehicle = item;
      this.selectedVehicle = item;
      this.enableTotDis = false;
      this.totalDistance = 0;
      let customStyle = {
        "width": "109px !important",
        "float": "right !important",
        "top": "10px!important",
        "margin-top": "-32px !important"
      }
      this.isVehicleDataHide = false;
      //console.log(item);
      //document.getElementById('routeInfoCollapseBtn').click();
      document.getElementById('mySidenav').style.display = 'block';
      this.mapHeight = '84.133%';
      // this.mapHeight = '75.7vh';
      this.stopRoutePlot();
      setTimeout(() => { this.reloadMap = false; }, 10);
    } else {
      return;
    }
  }
  selectedData(e) {
    // console.log(e);
    this.isShowMaps = !this.isShowMaps;
    /* this.openNav(e); */
  }
  addItem(e) {
    this.selecte = e;
    this.dashbordMenuChange(e);
  }

  //date picker
  dateFromAction(obj: any = {}, type) {
    if (type == 'startDate') {
      this.startDate = obj['selectedDates'][0];
      this.defaultEDate = obj.dateStr;
    }
    if (type == 'endDate') {
      this.endDate = obj['selectedDates'][0];
    }
    /*  obj.selectedDates.map((x: any) => {
       this.formObject[type] = x.getTime();
       // console.log(x.getTime())
     }); */
  }


  closeNav() {
    //document.getElementById('mySidenav').style.width = '0';
    this.isShowList = true;
    this.dateHideShow = false;
    this.vehRouteInfoHidePlot = false;
    this.startDate = undefined;
    this.endDate = undefined;
    this.startDateErr = '';
    this.endDateError = '';
    this.errorMessage = '';
    this.defaultEDate = undefined;
    this.reloadMap = true;
    this.removeVehicle = { ...this.selectedVehicle };
    this.selectedVehicle = {};
    this.singleViewVehicle = {};
    this.enableTotDis = false;
    this.totalDistance = 0;
    const sideNav = document.getElementById('mySidenav');
    if (sideNav) sideNav.style.display = 'none';
    this.mapHeight = '100%';
    this.summaryInfo = {};
    this.clickedVeh = '';

    this.stopRoutePlot();

    setTimeout(() => { this.dateHideShow = true; this.reloadMap = false; }, 10);
    // console.log(this.isShowMaps, this.map, this.selectedVehicle);
  }

  dateValidate(sdate, edate) {

    let isValid: boolean = true;
    if (sdate == undefined || sdate == null || sdate == '') {
      isValid = false;
      this.startDateErr = 'Start date is required.';
    }
    if (edate == undefined || edate == null || edate == '') {
      isValid = false;
      this.endDateError = 'End date is required.';
    }
    if (sdate && edate && new Date(sdate).getTime() > new Date(edate).getTime()) {
      isValid = false;
    }
    return isValid;
  }
  currentDayTrackingData(obj, startTs, endTs) {
    //getTrackingData
    return new Promise(async (resolve, reject) => {

      let trackingData = [];
      let res = await this.api.getTrackingData(obj).catch((e) => { console.log("Get tracking data"); });
      if (res && res['status'] == 'success') {
        if (res['data'].length <= 0) {
          this.errorMessage = 'No data found.';
          reject('error');
        }
        else {
          const getLatLng: any = await this.comService.filterLatLng(res['data'], startTs, endTs);
          this.getDistance(getLatLng);
          // if(getLatLng.length>0){
          //   this.share._subject.next({
          //     type: 'plot_line',
          //     data: getLatLng
          //   })
          //   this.errorMessage = 'false';
          // }
          trackingData = [...trackingData, ...getLatLng];
        }
      }
      if (trackingData.length > 0) this.errorMessage = 'false';
      resolve(trackingData);

    })
  }
  pingS3(tms, startTs, endTs) {
    return new Promise(async (resolve, reject) => {
      let d = new Date(tms);
      const pad = (num) => {
        return num > 9 ? (num + '') : '0' + num;
      };
       //let vehRegArray = [this.selectedVehicle['reg']];
        
      let datepath = pad(d.getDate()) + pad((d.getMonth() + 1)) + (d.getFullYear() + '').slice(-2);
      this.api.getVehicleRegNo({ vehRegNo: this.selectedVehicle['reg'] }).then(async (res: any) => {
      //this.api.getVehicleRegNo({ vehRegNo: vehRegArray }).then(async (res: any) => {
        let data = [];
        if (res && res['status'] == 'success') {
          // console.log(res['data'], this.selectedVehicle['reg'])
          const url = datepath + '/' + res['data'][this.selectedVehicle['reg']] + '.z';
          const response = await this.api.readS3Data(url).catch((e) => {
            // console.log('No data from S3')
            this.errorMessage = 'No data found.';
          });
          const getLatLng: any = await this.comService.filterLatLng(response, startTs, endTs);
          this.getDistance(getLatLng);
          data = [...data, ...getLatLng];
          // console.log('data',data);
          resolve(data);
        } else {
          resolve(data);
        }
      }).catch((e) => {
        reject({});
      })

    })
  }

  async getDistance(data) {
    let finalData = await this.processData(data, 0);
  }

  getVehTrackingData(tms, startTs, endTs) {
    return new Promise(async (resolve, reject) => {

      const checkCurrentDay = (date) => {
        var inputDate = new Date(date);
        // Get today's date
        var todaysDate = new Date();
        // call setHours to take the time out of the comparison
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
        else return false;
      };

      let isCurrentDay = checkCurrentDay(tms);
      let processedData: any = [];
      if (isCurrentDay) {
        let obj = {
          date: tms,
          vehRegNo: this.selectedVehicle['reg']
        }
        processedData = await this.currentDayTrackingData(obj, startTs, endTs);
      } else processedData = await this.pingS3(tms, startTs, endTs);
      // if (processedData.length > 0) {
      //   console.log('processedData ', isCurrentDay, processedData)
      //   // this.share._subject.next({
      //   //   type: 'plot_line',
      //   //   data: processedData
      //   // })
      // }

      resolve(processedData);

    })
  }

  async submitNav() {
    this.stopRoutePlot();
    const dateToTMS = (date) => {
      return new Date(date).getTime();
    };
    const pad = (num) => {
      return num > 9 ? num : '0' + num;
    };
    const arr: any = [];
    let getDaysArray: any = function (start, end) {
      for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
        const date = new Date(dt);
        arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
      }
      return arr;
    };
    this.enableTotDis = false;
    this.totalDistance = 0;
    let dates = getDaysArray(new Date(this.startDate), new Date(this.endDate));
    this.errorMessage = '', this.startDateErr = '', this.endDateError = '';
    if (dates.length > 2) {
      this.errorMessage = 'We allow only two days';
    } else {
      let checkDate = this.dateValidate(this.startDate, this.endDate);
      if (!checkDate && (this.startDateErr == '' && this.endDateError == '')) this.errorMessage = 'Start date should less than end date.';
      else {
        let location = [];
        let uniqueDate = [...new Set(dates)];
        for (let i = 0; i < uniqueDate.length; i++) {
          let tms = dateToTMS(uniqueDate[i]);
          // let startTs = new Date(new Date(this.startDate).setHours(0)).getTime();
          // let endTs = new Date(new Date(this.endDate).setHours(23,59,59)).getTime();
          let startTs = new Date(this.startDate).getTime();
          let endTs = new Date(this.endDate).getTime();
          let data: any = await this.getVehTrackingData(tms, startTs, endTs);
          location = [...location, ...data];
        }
        // console.log('location ', location)
        if ((location == [] || location.length <= 0) && this.startDateErr == '' && this.endDateError == '' && this.errorMessage != 'false') {
          this.errorMessage = 'No data found.'
        }
        if (location.length > 0) {
          this.share._subject.next({
            type: 'plot_line',
            data: location
          })
          this.vehRouteInfoHidePlot = true;
        }
      }

    }
    // console.log(dateToTMS(this.startDate[0]), 'End Date', dateToTMS(this.endDate[0]))


  }

  stopRoutePlot() {
    this.share._subject.next({
      type: 'plot_line',
      reset: true
    })
    this.vehRouteInfoHidePlot = false;
  }

  getActiveRouteInfo(orgID) {
    const obj = { orgID: orgID, };
    // console.log(obj);
    this.api.transportManagerRouteInformation(obj).then((res: any) => {
      if (res.status == 'success') {
        this.routeData = [...res.data];
        this.separateRoute();
        this.noActiveRouteEnable = true;
        //console.log(res.data);

      }
    }).catch((err) => {
      console.log(err);
    });
  }

  patchRouteData(data) {
    // console.log('DATA ', data);
    let vehiclesList = [];
    this.routeList = data.map((item: any, i: number) => {
      if (item.vehicle) vehiclesList = [...vehiclesList, ...item.vehicle];
      if (data.length - 1 == i) {
        this.share._subject.next({
          type: 'vehicle_current_location',
          data: vehiclesList
        })
      }
      return {
        title: item.title,
        trasitMode: item.trasitMode,
        attendence: typeof item.attendence == 'string' ? item.attendence : item.attendence.join(','),
        startTime: this.getTimeString(item.startTime),
        endTime: this.getTimeString(item.endTime),
        routeType: item.routeType,
        keywords: item.keywords,
        holidayPattern: item.holidayPattern,
        orgID: item.orgID,
        routeID: item.routeID,
        status: item.status,
        fromDate: this.comService.timestampToDate(item.fromDate, 'DMY', '-'),
        vehicle: item.vehicle ? item.vehicle : [],
      };
    });
  }

  loadRouteInfo(routeKey) {
    this.patchRouteData(this.routeTabData[routeKey]);
    // console.log(routeKey)
    this.selectedTapRouteExploar = routeKey;

    if (this.tabs.isRouteExploration) {
      this.tabs.isRouteExploration = !this.tabs.isRouteExploration;
      setTimeout(() => { this.tabs.isRouteExploration = !this.tabs.isRouteExploration }, 200);
    };
  }

  separateRoute() {

    Object.keys(this.routeTabCounts).filter((key) => this.routeTabCounts[key] = 0);
    Object.keys(this.routeTabData).filter((key) => this.routeTabData[key] = []);

    let dateTime = new Date();
    let hour = dateTime.getHours();
    let setHour = new Date(dateTime.setHours(hour + 5));
    let upcomingHour = setHour.getHours();
    // console.log('upcoming Hour', upcomingHour);
    this.routeData.filter((route) => {

      this.routeTabCounts['all']++;
      this.routeTabData['all'].push(route);

      if (route.startTime <= hour && route.endTime >= hour) {
        this.routeTabCounts['active']++;
        this.routeTabData['active'].push(route);
      }
      else if (route.startTime > hour) {
        this.routeTabCounts['upcoming']++;
        this.routeTabData['upcoming'].push(route);
      }
    });
    this.patchRouteData(this.routeTabData['active']);

  }

  processData(data: any, speed: any) {
    return new Promise((resolve, reject) => {
      // console.log('P1', data)
      try {
        let totalDis: any = 0;
        const procesedData: any = [];
        const speedLimit = ((speed == undefined) || (speed == null) || (speed == '')) ? 0 : speed;
        const sortingData = {};
        data.map((item) => {
          // item.speed = 44;
          item.date = this.comService.timestampToDate(item[4], 'DMY H:M:S');
          if (item[4] != undefined && +item[3] >= +speedLimit) {
            sortingData[item[4]] = item;
          }
        });
        const objKeys = Object.keys(sortingData);
        if (objKeys && objKeys.length) {
          let ind = 1;
          const temp: any = [];
          const tempEx = [];
          for (let i = 0; i < objKeys.length; i++) {
            let prevKey = null, next = null, currentKey = objKeys[i], pre = null;

            if (i > 0) { prevKey = procesedData[procesedData.length - 1]; }
            if (objKeys[i + 1]) { next = objKeys[i + 1]; }
            let curdis = 0;
            if (i > 0) {
              pre = objKeys[i - 1];
              const lat1 = parseFloat(sortingData[currentKey][0]);
              const lat2 = parseFloat(sortingData[pre][0]);
              const lng1 = parseFloat(sortingData[currentKey][1]);
              const lng2 = parseFloat(sortingData[pre][1]);
              if ((lat1 == lat2) && (lng1 == lng2)) { curdis = 0; } else {
                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                  dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = (dist * 1.609344);
                curdis = parseFloat(dist);
              }
            }
            totalDis = parseFloat(totalDis) + curdis;
          }
          this.totalDistance = Number((this.totalDistance + totalDis).toFixed(2));
          this.enableTotDis = true;
        }
        resolve(totalDis);
      } catch (err) {
        console.log('Total calculation', err);
        reject(err);
      }
    });
  }

  getTimeString(time) {                             // time '10:20'
    let timeString = String(time);
    let splitTime = timeString.split(".");            // 10, 20
    splitTime[1] = splitTime[1] == undefined ? '00' : splitTime[1];
    let hour = Number(splitTime[0]) < 10 ? '0' + splitTime[0] : splitTime[0];
    let minute = splitTime[1].length == 1 ? splitTime[1] + '0' : splitTime[1];
    // let minute = splitTime[1];
    let timeformat = `${hour}:${minute}`;
    return timeformat;
  }

  //reload tab content
  reloadTab(tab) {
    for (let key in this.tabs) {
      if (key == tab) this.tabs[key] = true;
      else this.tabs[key] = false;
    }

    if (tab == 'isRouteSummary' && tab == 'isOpenBookingSummary') {
      this.activeRouteExploration = false;
      this.selectedRoute = {};
    }
    else this.activeRouteExploration = true;

  }

  manageRoute(singleRoute) {
    let data: any = {
      isVehicleDataHide: true,
      selectedRoute: singleRoute,
      selectedTapRouteExploar: this.selectedTapRouteExploar,
    }
    this.storage.setData({ 'routeExploration': data });
    setTimeout(() => {
      this.router.navigate(['organization/transport-manager/rostering/edit-route/' + singleRoute['routeType'] + '/' + singleRoute['routeID'] + '/0'])
    }, 300)

    // console.log('organization/transport-manager/rostering/edit-route/' + singleRoute.routeType + '/' + singleRoute.routeID);
    this.router.navigate(['organization/transport-manager/rostering/edit-route/' + singleRoute.routeType + '/' + singleRoute.routeID + '/0'])
  }

  // isFilterChange(e){
  //   this.vehFilterslider=e;
  //   this.filterChange(e)
  // }

  // filterChange(e){
  //   this.filterData(this.selectedType);
  //   this.storage.setData({ isMapActiveVeh: this.vehFilterslider });
  // }
  loadMap() {
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        const mapOptions = {
          scrollwheel: true,
          zoom: 10,
          maxZoom: 17,
          center: new google.maps.LatLng(12.9716, 77.5946),
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('rosterMapDiv'), mapOptions);
        // const trafficLayer = new google.maps.TrafficLayer();
        // trafficLayer.setMap(this.googleMapObj);
      }, 1000)
    }
  }
  showEmpData(obj) {
    this.selEmp = [obj];
    this.rosterMapHeight = '80%';
    this.showRosterDetails = true;
    this.placeMarker(obj);
  }
  placeMarker(location) {

    let myLatlng = new google.maps.LatLng(location.lat, location.lng);
    if (this.globalGoogleMarker) {
      this.globalGoogleMarker.setMap(null);
    }
    let image = {
      url: `https://maps.google.com/mapfiles/ms/icons/${location.color}-dot.png`
    }

    this.globalGoogleMarker = new google.maps.Marker({
      position: location,
      map: this.googleMapObj,
      icon: image
    });
    this.googleMapObj.panTo(location);
    this.googleMapObj.setZoom(15);
  }
  closeEmpDetails() {
    this.rosterMapHeight = '100%';
    this.showRosterDetails = false;
    this.loadMap();
  }

  setDefaultDateTime() {
    const today = new Date();
    const defaultDate = today.toISOString().slice(0, 10); // Get today's date in YYYY-MM-DD format
    this.startDate = `${defaultDate}T00:00`; // Default time set to 00:00
  }

  // Function called when the input field is focused
  onFocus(event: Event) {
    if (!this.startDate) {
      this.setDefaultDateTime();
    }
  } ngAfterViewInit() {
    // Initialize Bootstrap popover
    $('[data-toggle="popover"]').popover({
      html: true,
    });
  }

}
